import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/evgImport',
  component: layout,
  meta: {
    funcID: 'E0004',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'usfsOrderData',
      name: `${pre}usfsOrderData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000401',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/usfsOrderData'),
    },
    {
      path: 'usfsInventoryData',
      name: `${pre}usfsInventoryData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000402',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/usfsInventoryData'),
    },
    {
      path: 'usfsInvoiceData',
      name: `${pre}usfsInvoiceData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000403',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/usfsInvoiceData'),
    },
    {
      path: 'platformOrderTransfer',
      name: `${pre}platformOrderTransfer`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000404',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/platformOrderTransfer'),
    },
    {
      path: 'shippedOrderMatching',
      name: `${pre}shippedOrderMatching`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000405',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/shippedOrderMatching'),
    },
    {
      path: 'lcInventory',
      name: `${pre}lcInventory`,
      meta: {
        ...meta,
        head: { back: false },
        cache: false,
        funcID: 'E000406',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/lcInventory'),
    },
    {
      path: 'wmPosSales',
      name: `${pre}wmPosSales`,
      meta: {
        ...meta,
        head: { back: false },
        cache: false,
        funcID: 'E000404',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/wmPosSales'),
    },
    {
      path: 'wmWeekPoImport',
      name: `${pre}wmWeekPoImport`,
      meta: {
        ...meta,
        head: { back: false },
        cache: false,
        funcID: 'E000405',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/evgImport/wmWeekPoImport'),
    }
  ])('ecom-evgImport-'),
}
